<template>
  <td>
    {{ $e("Position")}} :
  </td>
  <td>
    {{ DroneInDock }}
  </td>
  <td>
    <div v-html="cheackDroneInDock"></div>
  </td>
</template>
<script>
export default {
  props: {
    config: Object,
    cheack: Object,
  },

  computed: {
    DroneInDock() {
      let DroneInDock = this.config?.dock?.status?.drone_in_dock != null
        ? this.config.dock?.status.drone_in_dock
        : undefined;

      if (DroneInDock == 1) {
        return "Drone dans le dock";
      } else if (DroneInDock != undefined) {
        return "Drone absent du dock";
      }

      return "Position inconnue par rapport au dock";
    },

    cheackDroneInDock() {
      let DroneInDock = this.config?.dock?.status?.drone_in_dock != null
        ? this.config.dock?.status.drone_in_dock
        : undefined;

      return DroneInDock == 1
        ? this.cheack.ok
        : this.cheack.nok;
    },
  },
};
</script>
